import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

const WIDGET_EMBED_URL =
  "https://eodhljnwmkphervhvhio.supabase.co/functions/v1/widget-embed?widgetId=fb567272-c3db-4bf3-aba3-a2fc9d4e99ed&src=three_";

const SCRIPT_ID = "pesquisa-marca-indecx-embed";

const PesquisaMarcaIndecx: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 620 });

  useEffect(() => {
    if (isMobile) return;

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = WIDGET_EMBED_URL;
    script.async = true;
    script.onerror = () => {
      // eslint-disable-next-line no-console -- feedback de falha de carregamento do widget
      console.error(
        "[Ultra Widget] Falha ao carregar o widget de pesquisa de marca."
      );
    };
    document.head.appendChild(script);

    // eslint-disable-next-line consistent-return -- cleanup do useEffect é retornado de propósito
    return () => {
      const el = document.getElementById(SCRIPT_ID);
      if (el) el.remove();
    };
  }, [isMobile]);

  return null;
};

export { PesquisaMarcaIndecx };
